// source: witbooking/ari/v1/static_ari.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var witbooking_ari_v1_domain_pb = require('../../../witbooking/ari/v1/domain_pb.js');
goog.object.extend(proto, witbooking_ari_v1_domain_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.witbooking.ari.v1.ARIBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BoolBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BoolBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BundleRateType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BundleRestrictionType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.BundleType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CodesBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.CodesBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeviceTypeBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DeviceTypeBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DiscountRateType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DoubleBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.DoubleBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.IntBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.IntBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.MultipleParents', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.Occupancy', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticBundleData', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticComplementData', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticDiscountData', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticExtraData', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticInventoryData', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.StaticPropertyConfiguration', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.TimeWindowBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.TimeWindowBucketConfig.TypeCase', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.WeekDayBucketConfig', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.WeekDayBucketConfig.TypeCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.IntBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.IntBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.IntBucketConfig.displayName = 'proto.witbooking.ari.v1.IntBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DoubleBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.DoubleBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DoubleBucketConfig.displayName = 'proto.witbooking.ari.v1.DoubleBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.BoolBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.BoolBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.BoolBucketConfig.displayName = 'proto.witbooking.ari.v1.BoolBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.CodesBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.CodesBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.CodesBucketConfig.displayName = 'proto.witbooking.ari.v1.CodesBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.WeekDayBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.WeekDayBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.WeekDayBucketConfig.displayName = 'proto.witbooking.ari.v1.WeekDayBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.DeviceTypeBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.DeviceTypeBucketConfig.displayName = 'proto.witbooking.ari.v1.DeviceTypeBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_);
};
goog.inherits(proto.witbooking.ari.v1.TimeWindowBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.TimeWindowBucketConfig.displayName = 'proto.witbooking.ari.v1.TimeWindowBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.ARIBucketConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.ARIBucketConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.ARIBucketConfig.displayName = 'proto.witbooking.ari.v1.ARIBucketConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.MultipleParents = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.MultipleParents.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.MultipleParents, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.MultipleParents.displayName = 'proto.witbooking.ari.v1.MultipleParents';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticExtraData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticExtraData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticExtraData.displayName = 'proto.witbooking.ari.v1.StaticExtraData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticInventoryData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticInventoryData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticInventoryData.displayName = 'proto.witbooking.ari.v1.StaticInventoryData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.Occupancy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.Occupancy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.Occupancy.displayName = 'proto.witbooking.ari.v1.Occupancy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticDiscountData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticDiscountData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticDiscountData.displayName = 'proto.witbooking.ari.v1.StaticDiscountData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticPropertyConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticPropertyConfiguration.displayName = 'proto.witbooking.ari.v1.StaticPropertyConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticComplementData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticComplementData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticComplementData.displayName = 'proto.witbooking.ari.v1.StaticComplementData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.StaticBundleData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.StaticBundleData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.StaticBundleData.displayName = 'proto.witbooking.ari.v1.StaticBundleData';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.IntBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  FORMULA: 1,
  PARENT_TICKER: 2,
  CONSTANT: 3,
  PARENT_TICKERS: 4
};

/**
 * @return {proto.witbooking.ari.v1.IntBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.IntBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.IntBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.IntBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.IntBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    formula: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.NillableInt.toObject(includeInstance, f),
    parentTickers: (f = msg.getParentTickers()) && proto.witbooking.ari.v1.MultipleParents.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.IntBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.IntBucketConfig;
  return proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.IntBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormula(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.NillableInt;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableInt.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.MultipleParents;
      reader.readMessage(value,proto.witbooking.ari.v1.MultipleParents.deserializeBinaryFromReader);
      msg.setParentTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.IntBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.NillableInt.serializeBinaryToWriter
    );
  }
  f = message.getParentTickers();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.ari.v1.MultipleParents.serializeBinaryToWriter
    );
  }
};


/**
 * optional string formula = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.getFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.setFormula = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.clearFormula = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.hasFormula = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NillableInt constant = 3;
 * @return {?proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableInt} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableInt, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableInt|undefined} value
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
*/
proto.witbooking.ari.v1.IntBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MultipleParents parent_tickers = 4;
 * @return {?proto.witbooking.ari.v1.MultipleParents}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.getParentTickers = function() {
  return /** @type{?proto.witbooking.ari.v1.MultipleParents} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.MultipleParents, 4));
};


/**
 * @param {?proto.witbooking.ari.v1.MultipleParents|undefined} value
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
*/
proto.witbooking.ari.v1.IntBucketConfig.prototype.setParentTickers = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.ari.v1.IntBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.IntBucketConfig} returns this
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.clearParentTickers = function() {
  return this.setParentTickers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.IntBucketConfig.prototype.hasParentTickers = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  FORMULA: 1,
  PARENT_TICKER: 2,
  CONSTANT: 3,
  PARENT_TICKERS: 4
};

/**
 * @return {proto.witbooking.ari.v1.DoubleBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.DoubleBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DoubleBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DoubleBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DoubleBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    formula: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.NillableDouble.toObject(includeInstance, f),
    parentTickers: (f = msg.getParentTickers()) && proto.witbooking.ari.v1.MultipleParents.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DoubleBucketConfig;
  return proto.witbooking.ari.v1.DoubleBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DoubleBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormula(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.NillableDouble;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableDouble.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.MultipleParents;
      reader.readMessage(value,proto.witbooking.ari.v1.MultipleParents.deserializeBinaryFromReader);
      msg.setParentTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DoubleBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DoubleBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DoubleBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.NillableDouble.serializeBinaryToWriter
    );
  }
  f = message.getParentTickers();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.ari.v1.MultipleParents.serializeBinaryToWriter
    );
  }
};


/**
 * optional string formula = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.getFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.setFormula = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.clearFormula = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.hasFormula = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NillableDouble constant = 3;
 * @return {?proto.witbooking.ari.v1.NillableDouble}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableDouble} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableDouble, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableDouble|undefined} value
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
*/
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MultipleParents parent_tickers = 4;
 * @return {?proto.witbooking.ari.v1.MultipleParents}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.getParentTickers = function() {
  return /** @type{?proto.witbooking.ari.v1.MultipleParents} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.MultipleParents, 4));
};


/**
 * @param {?proto.witbooking.ari.v1.MultipleParents|undefined} value
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
*/
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.setParentTickers = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.ari.v1.DoubleBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DoubleBucketConfig} returns this
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.clearParentTickers = function() {
  return this.setParentTickers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DoubleBucketConfig.prototype.hasParentTickers = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.BoolBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  FORMULA: 1,
  PARENT_TICKER: 2,
  CONSTANT: 3,
  PARENT_TICKERS: 4
};

/**
 * @return {proto.witbooking.ari.v1.BoolBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.BoolBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.BoolBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.BoolBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BoolBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    formula: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.NillableBool.toObject(includeInstance, f),
    parentTickers: (f = msg.getParentTickers()) && proto.witbooking.ari.v1.MultipleParents.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig}
 */
proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.BoolBucketConfig;
  return proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.BoolBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig}
 */
proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormula(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.NillableBool;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.NillableBool.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.MultipleParents;
      reader.readMessage(value,proto.witbooking.ari.v1.MultipleParents.deserializeBinaryFromReader);
      msg.setParentTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.BoolBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.BoolBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.BoolBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.NillableBool.serializeBinaryToWriter
    );
  }
  f = message.getParentTickers();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.ari.v1.MultipleParents.serializeBinaryToWriter
    );
  }
};


/**
 * optional string formula = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.getFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.setFormula = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.clearFormula = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.hasFormula = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NillableBool constant = 3;
 * @return {?proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.NillableBool} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.NillableBool, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.NillableBool|undefined} value
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
*/
proto.witbooking.ari.v1.BoolBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MultipleParents parent_tickers = 4;
 * @return {?proto.witbooking.ari.v1.MultipleParents}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.getParentTickers = function() {
  return /** @type{?proto.witbooking.ari.v1.MultipleParents} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.MultipleParents, 4));
};


/**
 * @param {?proto.witbooking.ari.v1.MultipleParents|undefined} value
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
*/
proto.witbooking.ari.v1.BoolBucketConfig.prototype.setParentTickers = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.ari.v1.BoolBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.BoolBucketConfig} returns this
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.clearParentTickers = function() {
  return this.setParentTickers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.BoolBucketConfig.prototype.hasParentTickers = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.CodesBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  PARENT_TICKER: 2,
  CONSTANT: 3
};

/**
 * @return {proto.witbooking.ari.v1.CodesBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.CodesBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.CodesBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.CodesBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CodesBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.Codes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig}
 */
proto.witbooking.ari.v1.CodesBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.CodesBucketConfig;
  return proto.witbooking.ari.v1.CodesBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.CodesBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig}
 */
proto.witbooking.ari.v1.CodesBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.Codes;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.Codes.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.CodesBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.CodesBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.CodesBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.Codes.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig} returns this
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig} returns this
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Codes constant = 3;
 * @return {?proto.witbooking.ari.v1.Codes}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.Codes} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.Codes, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.Codes|undefined} value
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig} returns this
*/
proto.witbooking.ari.v1.CodesBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.CodesBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.CodesBucketConfig} returns this
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.CodesBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  PARENT_TICKER: 2,
  CONSTANT: 3
};

/**
 * @return {proto.witbooking.ari.v1.WeekDayBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.WeekDayBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.WeekDayBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.WeekDayBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.WeekDays.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.WeekDayBucketConfig;
  return proto.witbooking.ari.v1.WeekDayBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.WeekDayBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.WeekDays;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.WeekDays.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.WeekDayBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.WeekDayBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.WeekDays.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig} returns this
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig} returns this
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional WeekDays constant = 3;
 * @return {?proto.witbooking.ari.v1.WeekDays}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.WeekDays} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.WeekDays, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.WeekDays|undefined} value
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig} returns this
*/
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.WeekDayBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.WeekDayBucketConfig} returns this
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.WeekDayBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  PARENT_TICKER: 2,
  CONSTANT: 3
};

/**
 * @return {proto.witbooking.ari.v1.DeviceTypeBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.DeviceTypeBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.DeviceTypeBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.Devices.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.DeviceTypeBucketConfig;
  return proto.witbooking.ari.v1.DeviceTypeBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.Devices;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.Devices.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.DeviceTypeBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.Devices.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} returns this
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} returns this
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Devices constant = 3;
 * @return {?proto.witbooking.ari.v1.Devices}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.Devices} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.Devices, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.Devices|undefined} value
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} returns this
*/
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.DeviceTypeBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.DeviceTypeBucketConfig} returns this
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.DeviceTypeBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.TypeCase = {
  TYPE_NOT_SET: 0,
  PARENT_TICKER: 2,
  CONSTANT: 3
};

/**
 * @return {proto.witbooking.ari.v1.TimeWindowBucketConfig.TypeCase}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.getTypeCase = function() {
  return /** @type {proto.witbooking.ari.v1.TimeWindowBucketConfig.TypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.TimeWindowBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    constant: (f = msg.getConstant()) && witbooking_ari_v1_domain_pb.TimeWindows.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.TimeWindowBucketConfig;
  return proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.TimeWindowBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    case 3:
      var value = new witbooking_ari_v1_domain_pb.TimeWindows;
      reader.readMessage(value,witbooking_ari_v1_domain_pb.TimeWindows.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.TimeWindowBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      witbooking_ari_v1_domain_pb.TimeWindows.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent_ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig} returns this
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.setParentTicker = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig} returns this
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.clearParentTicker = function() {
  return jspb.Message.setOneofField(this, 2, proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.hasParentTicker = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TimeWindows constant = 3;
 * @return {?proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindows} */ (
    jspb.Message.getWrapperField(this, witbooking_ari_v1_domain_pb.TimeWindows, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindows|undefined} value
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig} returns this
*/
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.ari.v1.TimeWindowBucketConfig.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.TimeWindowBucketConfig} returns this
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.TimeWindowBucketConfig.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.ARIBucketConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.ARIBucketConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIBucketConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    rate: (f = msg.getRate()) && proto.witbooking.ari.v1.DoubleBucketConfig.toObject(includeInstance, f),
    availability: (f = msg.getAvailability()) && proto.witbooking.ari.v1.IntBucketConfig.toObject(includeInstance, f),
    minStay: (f = msg.getMinStay()) && proto.witbooking.ari.v1.IntBucketConfig.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && proto.witbooking.ari.v1.IntBucketConfig.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && proto.witbooking.ari.v1.IntBucketConfig.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && proto.witbooking.ari.v1.IntBucketConfig.toObject(includeInstance, f),
    codes: (f = msg.getCodes()) && proto.witbooking.ari.v1.CodesBucketConfig.toObject(includeInstance, f),
    checkinWeekdays: (f = msg.getCheckinWeekdays()) && proto.witbooking.ari.v1.WeekDayBucketConfig.toObject(includeInstance, f),
    checkoutWeekdays: (f = msg.getCheckoutWeekdays()) && proto.witbooking.ari.v1.WeekDayBucketConfig.toObject(includeInstance, f),
    devices: (f = msg.getDevices()) && proto.witbooking.ari.v1.DeviceTypeBucketConfig.toObject(includeInstance, f),
    openTravel: (f = msg.getOpenTravel()) && proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject(includeInstance, f),
    closeTravel: (f = msg.getCloseTravel()) && proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject(includeInstance, f),
    openBooking: (f = msg.getOpenBooking()) && proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject(includeInstance, f),
    closeBooking: (f = msg.getCloseBooking()) && proto.witbooking.ari.v1.TimeWindowBucketConfig.toObject(includeInstance, f),
    lock: (f = msg.getLock()) && proto.witbooking.ari.v1.BoolBucketConfig.toObject(includeInstance, f),
    closeToArrival: (f = msg.getCloseToArrival()) && proto.witbooking.ari.v1.BoolBucketConfig.toObject(includeInstance, f),
    closeToDeparture: (f = msg.getCloseToDeparture()) && proto.witbooking.ari.v1.BoolBucketConfig.toObject(includeInstance, f),
    rackRate: (f = msg.getRackRate()) && proto.witbooking.ari.v1.DoubleBucketConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.ARIBucketConfig;
  return proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.ARIBucketConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.DoubleBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.DoubleBucketConfig.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.IntBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.IntBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 4:
      var value = new proto.witbooking.ari.v1.IntBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 5:
      var value = new proto.witbooking.ari.v1.IntBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 6:
      var value = new proto.witbooking.ari.v1.IntBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.IntBucketConfig.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    case 7:
      var value = new proto.witbooking.ari.v1.CodesBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.CodesBucketConfig.deserializeBinaryFromReader);
      msg.setCodes(value);
      break;
    case 8:
      var value = new proto.witbooking.ari.v1.WeekDayBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.WeekDayBucketConfig.deserializeBinaryFromReader);
      msg.setCheckinWeekdays(value);
      break;
    case 9:
      var value = new proto.witbooking.ari.v1.WeekDayBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.WeekDayBucketConfig.deserializeBinaryFromReader);
      msg.setCheckoutWeekdays(value);
      break;
    case 10:
      var value = new proto.witbooking.ari.v1.DeviceTypeBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.DeviceTypeBucketConfig.deserializeBinaryFromReader);
      msg.setDevices(value);
      break;
    case 11:
      var value = new proto.witbooking.ari.v1.TimeWindowBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader);
      msg.setOpenTravel(value);
      break;
    case 12:
      var value = new proto.witbooking.ari.v1.TimeWindowBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader);
      msg.setCloseTravel(value);
      break;
    case 13:
      var value = new proto.witbooking.ari.v1.TimeWindowBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader);
      msg.setOpenBooking(value);
      break;
    case 14:
      var value = new proto.witbooking.ari.v1.TimeWindowBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.TimeWindowBucketConfig.deserializeBinaryFromReader);
      msg.setCloseBooking(value);
      break;
    case 15:
      var value = new proto.witbooking.ari.v1.BoolBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinaryFromReader);
      msg.setLock(value);
      break;
    case 16:
      var value = new proto.witbooking.ari.v1.BoolBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinaryFromReader);
      msg.setCloseToArrival(value);
      break;
    case 17:
      var value = new proto.witbooking.ari.v1.BoolBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.BoolBucketConfig.deserializeBinaryFromReader);
      msg.setCloseToDeparture(value);
      break;
    case 18:
      var value = new proto.witbooking.ari.v1.DoubleBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.DoubleBucketConfig.deserializeBinaryFromReader);
      msg.setRackRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.ARIBucketConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.ari.v1.DoubleBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.ari.v1.IntBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCodes();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.ari.v1.CodesBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCheckinWeekdays();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.ari.v1.WeekDayBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCheckoutWeekdays();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.ari.v1.WeekDayBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getDevices();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.witbooking.ari.v1.DeviceTypeBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getOpenTravel();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCloseTravel();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getOpenBooking();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCloseBooking();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.witbooking.ari.v1.TimeWindowBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getLock();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.witbooking.ari.v1.BoolBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCloseToArrival();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.witbooking.ari.v1.BoolBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getCloseToDeparture();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.witbooking.ari.v1.BoolBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getRackRate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.witbooking.ari.v1.DoubleBucketConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional DoubleBucketConfig rate = 1;
 * @return {?proto.witbooking.ari.v1.DoubleBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getRate = function() {
  return /** @type{?proto.witbooking.ari.v1.DoubleBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DoubleBucketConfig, 1));
};


/**
 * @param {?proto.witbooking.ari.v1.DoubleBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IntBucketConfig availability = 2;
 * @return {?proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getAvailability = function() {
  return /** @type{?proto.witbooking.ari.v1.IntBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.IntBucketConfig, 2));
};


/**
 * @param {?proto.witbooking.ari.v1.IntBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setAvailability = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearAvailability = function() {
  return this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional IntBucketConfig min_stay = 3;
 * @return {?proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.ari.v1.IntBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.IntBucketConfig, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.IntBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional IntBucketConfig max_stay = 4;
 * @return {?proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.ari.v1.IntBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.IntBucketConfig, 4));
};


/**
 * @param {?proto.witbooking.ari.v1.IntBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional IntBucketConfig min_notice = 5;
 * @return {?proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.ari.v1.IntBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.IntBucketConfig, 5));
};


/**
 * @param {?proto.witbooking.ari.v1.IntBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional IntBucketConfig max_notice = 6;
 * @return {?proto.witbooking.ari.v1.IntBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.ari.v1.IntBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.IntBucketConfig, 6));
};


/**
 * @param {?proto.witbooking.ari.v1.IntBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CodesBucketConfig codes = 7;
 * @return {?proto.witbooking.ari.v1.CodesBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCodes = function() {
  return /** @type{?proto.witbooking.ari.v1.CodesBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.CodesBucketConfig, 7));
};


/**
 * @param {?proto.witbooking.ari.v1.CodesBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCodes = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCodes = function() {
  return this.setCodes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCodes = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional WeekDayBucketConfig checkin_weekdays = 8;
 * @return {?proto.witbooking.ari.v1.WeekDayBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCheckinWeekdays = function() {
  return /** @type{?proto.witbooking.ari.v1.WeekDayBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.WeekDayBucketConfig, 8));
};


/**
 * @param {?proto.witbooking.ari.v1.WeekDayBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCheckinWeekdays = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCheckinWeekdays = function() {
  return this.setCheckinWeekdays(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCheckinWeekdays = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional WeekDayBucketConfig checkout_weekdays = 9;
 * @return {?proto.witbooking.ari.v1.WeekDayBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCheckoutWeekdays = function() {
  return /** @type{?proto.witbooking.ari.v1.WeekDayBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.WeekDayBucketConfig, 9));
};


/**
 * @param {?proto.witbooking.ari.v1.WeekDayBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCheckoutWeekdays = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCheckoutWeekdays = function() {
  return this.setCheckoutWeekdays(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCheckoutWeekdays = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional DeviceTypeBucketConfig devices = 10;
 * @return {?proto.witbooking.ari.v1.DeviceTypeBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getDevices = function() {
  return /** @type{?proto.witbooking.ari.v1.DeviceTypeBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DeviceTypeBucketConfig, 10));
};


/**
 * @param {?proto.witbooking.ari.v1.DeviceTypeBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setDevices = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearDevices = function() {
  return this.setDevices(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasDevices = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional TimeWindowBucketConfig open_travel = 11;
 * @return {?proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getOpenTravel = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindowBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.TimeWindowBucketConfig, 11));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindowBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setOpenTravel = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearOpenTravel = function() {
  return this.setOpenTravel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasOpenTravel = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TimeWindowBucketConfig close_travel = 12;
 * @return {?proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCloseTravel = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindowBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.TimeWindowBucketConfig, 12));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindowBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCloseTravel = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCloseTravel = function() {
  return this.setCloseTravel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCloseTravel = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TimeWindowBucketConfig open_booking = 13;
 * @return {?proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getOpenBooking = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindowBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.TimeWindowBucketConfig, 13));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindowBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setOpenBooking = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearOpenBooking = function() {
  return this.setOpenBooking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasOpenBooking = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional TimeWindowBucketConfig close_booking = 14;
 * @return {?proto.witbooking.ari.v1.TimeWindowBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCloseBooking = function() {
  return /** @type{?proto.witbooking.ari.v1.TimeWindowBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.TimeWindowBucketConfig, 14));
};


/**
 * @param {?proto.witbooking.ari.v1.TimeWindowBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCloseBooking = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCloseBooking = function() {
  return this.setCloseBooking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCloseBooking = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional BoolBucketConfig lock = 15;
 * @return {?proto.witbooking.ari.v1.BoolBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getLock = function() {
  return /** @type{?proto.witbooking.ari.v1.BoolBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.BoolBucketConfig, 15));
};


/**
 * @param {?proto.witbooking.ari.v1.BoolBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setLock = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearLock = function() {
  return this.setLock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasLock = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional BoolBucketConfig close_to_arrival = 16;
 * @return {?proto.witbooking.ari.v1.BoolBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCloseToArrival = function() {
  return /** @type{?proto.witbooking.ari.v1.BoolBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.BoolBucketConfig, 16));
};


/**
 * @param {?proto.witbooking.ari.v1.BoolBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCloseToArrival = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCloseToArrival = function() {
  return this.setCloseToArrival(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCloseToArrival = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional BoolBucketConfig close_to_departure = 17;
 * @return {?proto.witbooking.ari.v1.BoolBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getCloseToDeparture = function() {
  return /** @type{?proto.witbooking.ari.v1.BoolBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.BoolBucketConfig, 17));
};


/**
 * @param {?proto.witbooking.ari.v1.BoolBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setCloseToDeparture = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearCloseToDeparture = function() {
  return this.setCloseToDeparture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasCloseToDeparture = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional DoubleBucketConfig rack_rate = 18;
 * @return {?proto.witbooking.ari.v1.DoubleBucketConfig}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.getRackRate = function() {
  return /** @type{?proto.witbooking.ari.v1.DoubleBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.DoubleBucketConfig, 18));
};


/**
 * @param {?proto.witbooking.ari.v1.DoubleBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
*/
proto.witbooking.ari.v1.ARIBucketConfig.prototype.setRackRate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.ARIBucketConfig} returns this
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.clearRackRate = function() {
  return this.setRackRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.ARIBucketConfig.prototype.hasRackRate = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.MultipleParents.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.MultipleParents.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.MultipleParents.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.MultipleParents} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.MultipleParents.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.MultipleParents}
 */
proto.witbooking.ari.v1.MultipleParents.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.MultipleParents;
  return proto.witbooking.ari.v1.MultipleParents.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.MultipleParents} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.MultipleParents}
 */
proto.witbooking.ari.v1.MultipleParents.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addParentTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.MultipleParents.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.MultipleParents.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.MultipleParents} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.MultipleParents.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParentTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string parent_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.MultipleParents.prototype.getParentTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.MultipleParents} returns this
 */
proto.witbooking.ari.v1.MultipleParents.prototype.setParentTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.MultipleParents} returns this
 */
proto.witbooking.ari.v1.MultipleParents.prototype.addParentTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.MultipleParents} returns this
 */
proto.witbooking.ari.v1.MultipleParents.prototype.clearParentTickersList = function() {
  return this.setParentTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticExtraData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticExtraData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticExtraData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mandatory: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    bucketConfig: (f = msg.getBucketConfig()) && proto.witbooking.ari.v1.ARIBucketConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticExtraData}
 */
proto.witbooking.ari.v1.StaticExtraData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticExtraData;
  return proto.witbooking.ari.v1.StaticExtraData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticExtraData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticExtraData}
 */
proto.witbooking.ari.v1.StaticExtraData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMandatory(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.ARIBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader);
      msg.setBucketConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticExtraData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticExtraData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticExtraData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMandatory();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBucketConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticExtraData} returns this
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool mandatory = 2;
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.getMandatory = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.StaticExtraData} returns this
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.setMandatory = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional ARIBucketConfig bucket_config = 3;
 * @return {?proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.getBucketConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.ARIBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.ARIBucketConfig, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.ARIBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticExtraData} returns this
*/
proto.witbooking.ari.v1.StaticExtraData.prototype.setBucketConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticExtraData} returns this
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.clearBucketConfig = function() {
  return this.setBucketConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticExtraData.prototype.hasBucketConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticInventoryData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticInventoryData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticInventoryData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    occupancy: (f = msg.getOccupancy()) && proto.witbooking.ari.v1.Occupancy.toObject(includeInstance, f),
    accommodation: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mealPlan: jspb.Message.getFieldWithDefault(msg, 5, ""),
    condition: jspb.Message.getFieldWithDefault(msg, 6, ""),
    bucketConfig: (f = msg.getBucketConfig()) && proto.witbooking.ari.v1.ARIBucketConfig.toObject(includeInstance, f),
    active: (f = msg.getActive()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticInventoryData}
 */
proto.witbooking.ari.v1.StaticInventoryData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticInventoryData;
  return proto.witbooking.ari.v1.StaticInventoryData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticInventoryData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticInventoryData}
 */
proto.witbooking.ari.v1.StaticInventoryData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.Occupancy;
      reader.readMessage(value,proto.witbooking.ari.v1.Occupancy.deserializeBinaryFromReader);
      msg.setOccupancy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodation(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMealPlan(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCondition(value);
      break;
    case 12:
      var value = new proto.witbooking.ari.v1.ARIBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader);
      msg.setBucketConfig(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticInventoryData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticInventoryData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticInventoryData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOccupancy();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.ari.v1.Occupancy.serializeBinaryToWriter
    );
  }
  f = message.getAccommodation();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMealPlan();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCondition();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBucketConfig();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Occupancy occupancy = 3;
 * @return {?proto.witbooking.ari.v1.Occupancy}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getOccupancy = function() {
  return /** @type{?proto.witbooking.ari.v1.Occupancy} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.Occupancy, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.Occupancy|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
*/
proto.witbooking.ari.v1.StaticInventoryData.prototype.setOccupancy = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.clearOccupancy = function() {
  return this.setOccupancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.hasOccupancy = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string accommodation = 4;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getAccommodation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.setAccommodation = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string meal_plan = 5;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getMealPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.setMealPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string condition = 6;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.setCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ARIBucketConfig bucket_config = 12;
 * @return {?proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getBucketConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.ARIBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.ARIBucketConfig, 12));
};


/**
 * @param {?proto.witbooking.ari.v1.ARIBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
*/
proto.witbooking.ari.v1.StaticInventoryData.prototype.setBucketConfig = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.clearBucketConfig = function() {
  return this.setBucketConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.hasBucketConfig = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue active = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.getActive = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
*/
proto.witbooking.ari.v1.StaticInventoryData.prototype.setActive = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticInventoryData} returns this
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.clearActive = function() {
  return this.setActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticInventoryData.prototype.hasActive = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.Occupancy.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.Occupancy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.Occupancy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Occupancy.toObject = function(includeInstance, msg) {
  var f, obj = {
    adults: jspb.Message.getFieldWithDefault(msg, 1, 0),
    children: jspb.Message.getFieldWithDefault(msg, 2, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 3, 0),
    seniors: jspb.Message.getFieldWithDefault(msg, 4, 0),
    teenagers: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.Occupancy}
 */
proto.witbooking.ari.v1.Occupancy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.Occupancy;
  return proto.witbooking.ari.v1.Occupancy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.Occupancy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.Occupancy}
 */
proto.witbooking.ari.v1.Occupancy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeniors(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeenagers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.Occupancy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.Occupancy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.Occupancy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Occupancy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSeniors();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTeenagers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 adults = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.Occupancy.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.Occupancy} returns this
 */
proto.witbooking.ari.v1.Occupancy.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 children = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.Occupancy.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.Occupancy} returns this
 */
proto.witbooking.ari.v1.Occupancy.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 babies = 3;
 * @return {number}
 */
proto.witbooking.ari.v1.Occupancy.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.Occupancy} returns this
 */
proto.witbooking.ari.v1.Occupancy.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 seniors = 4;
 * @return {number}
 */
proto.witbooking.ari.v1.Occupancy.prototype.getSeniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.Occupancy} returns this
 */
proto.witbooking.ari.v1.Occupancy.prototype.setSeniors = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 teenagers = 5;
 * @return {number}
 */
proto.witbooking.ari.v1.Occupancy.prototype.getTeenagers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.Occupancy} returns this
 */
proto.witbooking.ari.v1.Occupancy.prototype.setTeenagers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticDiscountData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticDiscountData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticDiscountData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rateType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bucketConfig: (f = msg.getBucketConfig()) && proto.witbooking.ari.v1.ARIBucketConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticDiscountData}
 */
proto.witbooking.ari.v1.StaticDiscountData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticDiscountData;
  return proto.witbooking.ari.v1.StaticDiscountData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticDiscountData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticDiscountData}
 */
proto.witbooking.ari.v1.StaticDiscountData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.ari.v1.DiscountRateType} */ (reader.readEnum());
      msg.setRateType(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.ARIBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader);
      msg.setBucketConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticDiscountData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticDiscountData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticDiscountData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRateType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBucketConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticDiscountData} returns this
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DiscountRateType rate_type = 2;
 * @return {!proto.witbooking.ari.v1.DiscountRateType}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.getRateType = function() {
  return /** @type {!proto.witbooking.ari.v1.DiscountRateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.DiscountRateType} value
 * @return {!proto.witbooking.ari.v1.StaticDiscountData} returns this
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.setRateType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ARIBucketConfig bucket_config = 3;
 * @return {?proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.getBucketConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.ARIBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.ARIBucketConfig, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.ARIBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticDiscountData} returns this
*/
proto.witbooking.ari.v1.StaticDiscountData.prototype.setBucketConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticDiscountData} returns this
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.clearBucketConfig = function() {
  return this.setBucketConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticDiscountData.prototype.hasBucketConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticPropertyConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticPropertyConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    defaultCurrency: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticPropertyConfiguration}
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticPropertyConfiguration;
  return proto.witbooking.ari.v1.StaticPropertyConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticPropertyConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticPropertyConfiguration}
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticPropertyConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticPropertyConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDefaultCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string default_currency = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.prototype.getDefaultCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticPropertyConfiguration} returns this
 */
proto.witbooking.ari.v1.StaticPropertyConfiguration.prototype.setDefaultCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticComplementData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticComplementData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticComplementData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bucketConfig: (f = msg.getBucketConfig()) && proto.witbooking.ari.v1.ARIBucketConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticComplementData}
 */
proto.witbooking.ari.v1.StaticComplementData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticComplementData;
  return proto.witbooking.ari.v1.StaticComplementData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticComplementData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticComplementData}
 */
proto.witbooking.ari.v1.StaticComplementData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.ari.v1.ARIBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader);
      msg.setBucketConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticComplementData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticComplementData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticComplementData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBucketConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticComplementData} returns this
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ARIBucketConfig bucket_config = 3;
 * @return {?proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.getBucketConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.ARIBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.ARIBucketConfig, 3));
};


/**
 * @param {?proto.witbooking.ari.v1.ARIBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticComplementData} returns this
*/
proto.witbooking.ari.v1.StaticComplementData.prototype.setBucketConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticComplementData} returns this
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.clearBucketConfig = function() {
  return this.setBucketConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticComplementData.prototype.hasBucketConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.StaticBundleData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.StaticBundleData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticBundleData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bundleRateType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    oneTimeFormula: jspb.Message.getFieldWithDefault(msg, 3, ""),
    bundleRestrictionType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    bucketConfig: (f = msg.getBucketConfig()) && proto.witbooking.ari.v1.ARIBucketConfig.toObject(includeInstance, f),
    bundleTicker: jspb.Message.getFieldWithDefault(msg, 6, ""),
    bundleType: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.StaticBundleData}
 */
proto.witbooking.ari.v1.StaticBundleData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.StaticBundleData;
  return proto.witbooking.ari.v1.StaticBundleData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.StaticBundleData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.StaticBundleData}
 */
proto.witbooking.ari.v1.StaticBundleData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.ari.v1.BundleRateType} */ (reader.readEnum());
      msg.setBundleRateType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOneTimeFormula(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.ari.v1.BundleRestrictionType} */ (reader.readEnum());
      msg.setBundleRestrictionType(value);
      break;
    case 5:
      var value = new proto.witbooking.ari.v1.ARIBucketConfig;
      reader.readMessage(value,proto.witbooking.ari.v1.ARIBucketConfig.deserializeBinaryFromReader);
      msg.setBucketConfig(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBundleTicker(value);
      break;
    case 7:
      var value = /** @type {!proto.witbooking.ari.v1.BundleType} */ (reader.readEnum());
      msg.setBundleType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.StaticBundleData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.StaticBundleData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.StaticBundleData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBundleRateType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOneTimeFormula();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBundleRestrictionType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getBucketConfig();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.ari.v1.ARIBucketConfig.serializeBinaryToWriter
    );
  }
  f = message.getBundleTicker();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBundleType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BundleRateType bundle_rate_type = 2;
 * @return {!proto.witbooking.ari.v1.BundleRateType}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getBundleRateType = function() {
  return /** @type {!proto.witbooking.ari.v1.BundleRateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.BundleRateType} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setBundleRateType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string one_time_formula = 3;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getOneTimeFormula = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setOneTimeFormula = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional BundleRestrictionType bundle_restriction_type = 4;
 * @return {!proto.witbooking.ari.v1.BundleRestrictionType}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getBundleRestrictionType = function() {
  return /** @type {!proto.witbooking.ari.v1.BundleRestrictionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.BundleRestrictionType} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setBundleRestrictionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ARIBucketConfig bucket_config = 5;
 * @return {?proto.witbooking.ari.v1.ARIBucketConfig}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getBucketConfig = function() {
  return /** @type{?proto.witbooking.ari.v1.ARIBucketConfig} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.ARIBucketConfig, 5));
};


/**
 * @param {?proto.witbooking.ari.v1.ARIBucketConfig|undefined} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
*/
proto.witbooking.ari.v1.StaticBundleData.prototype.setBucketConfig = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.clearBucketConfig = function() {
  return this.setBucketConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.hasBucketConfig = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string bundle_ticker = 6;
 * @return {string}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getBundleTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setBundleTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional BundleType bundle_type = 7;
 * @return {!proto.witbooking.ari.v1.BundleType}
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.getBundleType = function() {
  return /** @type {!proto.witbooking.ari.v1.BundleType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.witbooking.ari.v1.BundleType} value
 * @return {!proto.witbooking.ari.v1.StaticBundleData} returns this
 */
proto.witbooking.ari.v1.StaticBundleData.prototype.setBundleType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.DiscountRateType = {
  DISCOUNT_RATE_TYPE_INVALID: 0,
  DISCOUNT_RATE_TYPE_FIXED: 1,
  DISCOUNT_RATE_TYPE_PERCENTAGE: 2
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.BundleRateType = {
  BUNDLE_TYPE_FIXED: 0,
  BUNDLE_TYPE_DYNAMIC: 1,
  BUNDLE_TYPE_OWN: 2
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.BundleRestrictionType = {
  OWN_RESTRICTION_TYPE: 0,
  SHARED_RESTRICTION_TYPE: 1
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.BundleType = {
  BUNDLE_TYPE_STANDARD: 0,
  BUNDLE_TYPE_LITE: 1
};

goog.object.extend(exports, proto.witbooking.ari.v1);
